"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemInputTransport = exports.LineItemEntityData = exports.LineItemTransport = exports.LineItemReferenceTransport = exports.DefaultTaxableLineItems = exports.DefaultLineItemLabels = exports.DefaultLineItem = exports.DefaultLineItems = void 0;
const typebox_1 = require("@sinclair/typebox");
const entity_reference_1 = require("../common/entity-reference");
const line_item_entity_data_1 = require("../common/line-item-entity-data");
Object.defineProperty(exports, "LineItemEntityData", { enumerable: true, get: function () { return line_item_entity_data_1.LineItemEntityData; } });
// Default Taxable Line Items
exports.DefaultLineItems = ['QP-Dump', 'dump', 'QP-Haul', 'haul', 'Overage'];
exports.DefaultLineItem = typebox_1.Type.Union(exports.DefaultLineItems.map((e) => typebox_1.Type.Literal(e)));
exports.DefaultLineItemLabels = {
    'QP-Dump': 'QP-Dump',
    dump: 'Dump',
    'QP-Haul': 'QP-Haul',
    haul: 'Haul',
    Overage: 'Overage',
};
exports.DefaultTaxableLineItems = ['QP-Haul'];
exports.LineItemReferenceTransport = typebox_1.Type.Intersect([
    entity_reference_1.EntityReference,
    typebox_1.Type.Object({
        entityData: typebox_1.Type.Optional(line_item_entity_data_1.LineItemEntityData),
    }),
]);
exports.LineItemTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    itemName: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitPriceDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    totalPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    totalPriceDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxable: typebox_1.Type.Boolean(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * @deprecated Use references instead
     */
    serviceOrderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    references: typebox_1.Type.Optional(typebox_1.Type.Array(exports.LineItemReferenceTransport)),
    metadata: typebox_1.Type.Optional(typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    })),
});
exports.LineItemInputTransport = typebox_1.Type.Omit(exports.LineItemTransport, ['id', 'metadata', 'haulerID']);
//# sourceMappingURL=line-item-transport.js.map